
export default {
  // Navigation
  "nav.home": "Home",
  "nav.about": "About Us", 
  "nav.services": "Services",
  "nav.products": "Products",
  "nav.certifications": "Certifications",
  "nav.partnerships": "Partnerships",
  "nav.contact": "Contact",
  "nav.quote": "Get Quote",
  
  // Common buttons
  "button.learnMore": "Learn More",
  "button.getQuote": "Get Quote",
  "button.contactUs": "Contact Us",
  "button.viewAll": "View All",
  "button.download": "Download",
  
  // Company
  "company.name": "DRIXEM GROUP",
  "company.tagline": "Malaysian Palm Oil Specialists",
  "company.description": "Leading Malaysian palm oil specialist providing quality products and services to global markets.",
  
  // Footer
  "footer.quickLinks": "Quick Links",
  "footer.services": "Services", 
  "footer.contact": "Contact Info",
  "footer.allRights": "All rights reserved.",
  
  // Certifications
  "certifications.regulatory.title": "Regulatory Compliance Excellence",
  "certifications.regulatory.description": "We maintain strict compliance with all Malaysian government regulations and international standards. Our comprehensive certification portfolio demonstrates our commitment to quality, safety, and legal compliance in all operations.",
  "certifications.regulatory.authority": "Government Authority Approval",
  "certifications.regulatory.authorityDesc": "All certifications issued by official Malaysian government ministries and departments.",
  "certifications.regulatory.monitoring": "Continuous Monitoring",
  "certifications.regulatory.monitoringDesc": "Regular audits and assessments to ensure ongoing compliance with all requirements.",
  "certifications.regulatory.renewals": "Timely Renewals",
  "certifications.regulatory.renewalsDesc": "Proactive renewal process to maintain valid certifications without interruption.",
  "certifications.requestCertificates": "Request Certificate Copies",
  
  // Common
  "language.current": "English",

  // Updated Company (overrides)
  'company.name': 'DRIXEM GROUP',
  'company.tagline': 'Malaysian Palm Oil Specialist',
  'company.description': 'Leading Malaysian palm oil specialist providing quality products and services to global markets.',

  // Navigation (overrides)
  'nav.home': 'Home',
  'nav.about': 'About',
  'nav.services': 'Services', 
  'nav.products': 'Products',
  'nav.certifications': 'Certifications',
  'nav.partnerships': 'Partnerships',
  'nav.contact': 'Contact',
  'nav.quote': 'Get Quote',

  // Footer (overrides)
  'footer.quickLinks': 'Quick Links',
  'footer.services': 'Services',
  'footer.contact': 'Contact Info',
  'footer.allRights': 'All rights reserved.',

  // Products Page
  'products.hero.title': 'Our Products',
  'products.hero.subtitle': 'Premium Malaysian palm oil products trusted by clients worldwide',

  'products.grades.title': 'Palm Oil Grades',
  'products.grades.subtitle': 'High-quality refined palm oil available in CP6, CP8, and CP10 grades to meet diverse market requirements',

  'products.cp6.name': 'CP6 Grade (Super Palm Olein)',
  'products.cp6.description': 'The highest quality liquid palm oil with Cloud Point ≤6°C, often termed Super Palm Olein. This is the most refined grade with the highest unsaturation (minimum IV of 58-60), making it the most liquid and appropriate for cooler climates and premium applications.',
  'products.cp6.app1': 'Premium Food Manufacturing',
  'products.cp6.app2': 'Cooler Climate Markets',
  'products.cp6.app3': 'High-End Commercial Cooking',
  'products.cp6.app4': 'Export to Temperate Regions',
  'products.cp6.techNote': 'Most liquid grade - remains fluid at lowest temperatures due to highest unsaturation level',

  'products.cp8.name': 'CP8 Grade',
  'products.cp8.description': 'More refined palm oil with Cloud Point ≤8°C and minimum IV of 56-57. This grade is more liquid than standard palm olein and better suited for slightly cooler environments while maintaining excellent stability.',
  'products.cp8.app1': 'Industrial Cooking',
  'products.cp8.app2': 'Food Processing',
  'products.cp8.app3': 'Moderate Climate Markets',
  'products.cp8.app4': 'Wholesale Distribution',
  'products.cp8.techNote': 'Enhanced liquidity - improved flow characteristics in cooler conditions',

  'products.cp10.name': 'CP10 Grade (Standard Palm Olein)',
  'products.cp10.description': 'Standard Palm Olein with Cloud Point ≤10°C and minimum IV of 54-56. This is the standard grade for general cooking and frying applications, offering reliable quality and competitive pricing.',
  'products.cp10.app1': 'General Cooking & Frying',
  'products.cp10.app2': 'Food Service Industry',
  'products.cp10.app3': 'Local Markets',
  'products.cp10.app4': 'Standard Export Trade',
  'products.cp10.techNote': 'Standard grade - optimal balance of performance and cost-effectiveness',

  'products.specs.title': 'Technical Specifications',
  'products.specs.cloudPoint': 'Cloud Point (CP)',
  'products.specs.iodineValue': 'Iodine Value (IV)',
  'products.specs.freeAcid': 'Free Fatty Acid',
  'products.specs.moisture': 'Moisture & Impurities',
  'products.specs.peroxide': 'Peroxide Value',
  'products.specs.color': 'Color (5¼" Lovibond)',

  'products.applications.title': 'Applications',
  'products.techNote.label': 'Technical Note',
  'products.requestQuote': 'Request Quote',

  'products.technical.title': 'Understanding RBD Palm Olein Grades',
  'products.technical.subtitle': 'The various grades of Refined, Bleached, and Deodorized (RBD) Palm Olein are classified by their Cloud Point (CP) - the temperature at which oil begins to solidify and appear cloudy.',
  'products.technical.correlation': 'Cloud Point & Iodine Value Correlation',
  'products.technical.cp.title': 'What is Cloud Point (CP)?',
  'products.technical.cp.desc': 'The temperature at which the oil begins to solidify and appear cloudy. Lower CP means the oil remains liquid at cooler temperatures.',
  'products.technical.iv.title': 'What is Iodine Value (IV)?',
  'products.technical.iv.desc': 'A measure of oil\'s unsaturation (number of double bonds). Higher IV indicates more liquid oil at lower temperatures and better flow characteristics.',
  'products.technical.process.title': 'Fractionation Process',
  'products.technical.process.desc': 'Different CP grades are produced through further fractionation to remove saturated fats (stearin), effectively lowering the CP and increasing the IV.',
  'products.technical.chart.title': 'Grade Comparison Chart',
  'products.technical.chart.super': 'Super Olein',
  'products.technical.chart.refined': 'Most Refined',
  'products.technical.chart.enhanced': 'Enhanced Liquid',
  'products.technical.chart.standard': 'Standard',
  'products.technical.chart.general': 'General Purpose',
  'products.technical.chart.relationship': 'As CP decreases',
  'products.technical.chart.note': 'Oil becomes more refined, unsaturation increases, and remains liquid at lower temperatures',
  'products.technical.relationships.title': 'Key Technical Relationships',
  'products.technical.relationships.cp': 'Lower Cloud Point',
  'products.technical.relationships.cpDesc': 'Better performance in cooler climates and refrigerated conditions',
  'products.technical.relationships.iv': 'Higher Iodine Value',
  'products.technical.relationships.ivDesc': 'Increased unsaturation leads to better fluidity and flow characteristics',
  'products.technical.relationships.process': 'Advanced Fractionation',
  'products.technical.relationships.processDesc': 'More refined processing removes saturated fats for premium grades',

  'products.brands.title': 'Our OEM Brands',
  'products.brands.subtitle': 'Established brands and custom OEM solutions for diverse market segments',
  'products.brands.features': 'Key Features',
  'products.brands.targetMarket': 'Target Market',
  'products.brands.learnMore': 'Learn More',

  'products.tahfiz.description': 'Premium halal-certified Malaysian cooking oil brand designed for Islamic markets with superior quality and Malaysian heritage.',
  'products.tahfiz.feat1': '100% Malaysian Halal Certified',
  'products.tahfiz.feat2': 'Premium Malaysian Quality',
  'products.tahfiz.feat3': 'Islamic Market Focus',
  'products.tahfiz.feat4': 'Authentic Malaysian Product',
  'products.tahfiz.market': 'Middle East, Southeast Asia, Global Islamic Communities',

  'products.hafizah.description': 'High-quality Malaysian cooking oil brand for health-conscious consumers, emphasizing Malaysian nutrition standards and wellness benefits.',
  'products.hafizah.feat1': 'Malaysian Health Standards',
  'products.hafizah.feat2': 'Nutritional Benefits',
  'products.hafizah.feat3': 'Premium Malaysian Packaging',
  'products.hafizah.feat4': 'Quality Assurance',
  'products.hafizah.market': 'Health-conscious consumers, Premium retail markets',

  'products.oem.name': 'Custom OEM',
  'products.oem.description': 'Complete private label solutions manufactured in Malaysia with customizable packaging, formulations, and Malaysian quality specifications.',
  'products.oem.feat1': 'Malaysian Private Labeling',
  'products.oem.feat2': 'Custom Malaysian Formulations',
  'products.oem.feat3': 'Flexible Malaysian Packaging',
  'products.oem.feat4': 'Malaysian Brand Development Support',
  'products.oem.market': 'International Retailers, Distributors, Food Manufacturers',

  'products.packaging.title': 'Packaging Options',
  'products.packaging.subtitle': 'Flexible packaging solutions to meet your specific requirements and market needs',
  'products.packaging.sizes': 'Available Sizes',
  'products.packaging.retail.type': 'Retail Packaging',
  'products.packaging.retail.desc': 'Consumer-friendly packaging for retail markets',
  'products.packaging.bulk.type': 'Bulk Packaging',
  'products.packaging.bulk.desc': 'Industrial packaging for bulk buyers and processors',
  'products.packaging.bulk.flexitank': 'Flexi Tank/Bag (23.5 Metric Tonne)',
  'products.packaging.vessel.type': 'Bulk Vessel',
  'products.packaging.vessel.desc': 'Specialized packaging for large-volume international export orders',
  'products.packaging.vessel.custom': 'Custom Vessel Orders',
  'products.packaging.vessel.volume': 'Large Volume Export',
  'products.packaging.vessel.container': 'Container Loads',
  'products.packaging.vessel.tanker': 'Tanker Shipments',
  'products.packaging.custom.type': 'Custom Packaging',
  'products.packaging.custom.desc': 'Tailored packaging solutions for specific requirements',
  'products.packaging.custom.pouches': 'Pouches',
  'products.packaging.custom.glass': 'Glass Bottles',
  'products.packaging.custom.pet': 'PET Bottles',
  'products.packaging.custom.tin': 'Tin Containers',

  'products.quality.title': 'Malaysian Quality Assurance',
  'products.quality.description': 'Our products undergo rigorous quality control processes in Malaysian facilities to ensure they meet the highest national and international standards. From Malaysian plantation sourcing to final packaging, every step is monitored and tested according to Malaysian government regulations.',
  'products.quality.jakim': 'JAKIM Halal Certified',
  'products.quality.mpob': 'MPOB Certified',
  'products.quality.moh': 'Malaysian MOH Approved',
  'products.quality.export': 'Malaysian Export License',
  'products.quality.altText': 'Malaysian Quality Assurance Laboratory',

  'products.export.title': 'Global Export Capabilities',
  'products.export.subtitle': 'Serving international markets across all five continents with reliable Malaysian supply chains and professional export logistics',
  'products.export.continents': '5 Continents',
  'products.export.continentsDesc': 'Exporting Malaysian palm oil to all five continents including Australia and Oceania',
  'products.export.ports': 'Malaysian Port Access',
  'products.export.portsDesc': 'Direct access to major Malaysian ports for efficient global shipping',
  'products.export.delivery': 'On-Time Delivery',
  'products.export.deliveryDesc': '99% on-time delivery rate with reliable schedules',
  'products.export.support': '24/7 Support',
  'products.export.supportDesc': 'Round-the-clock customer support and tracking',

  'products.cta.title': 'Interested in Malaysian Palm Oil Products?',
  'products.cta.subtitle': 'Contact us today to discuss your requirements and get a customized quote for our premium Malaysian palm oil products.',
  'products.cta.certifications': 'View Certifications'
};
